import type { RefObject } from 'react';
import { findTransitionController } from '../../../../util/core-transition-component';

interface ServicePowerSlideRefs {
  elementRef?: RefObject<HTMLDivElement | null>;
  textContentRef?: RefObject<HTMLDivElement | null>;
  titleRef?: RefObject<HTMLHeadingElement | null>;
  descriptionRef?: RefObject<HTMLParagraphElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, descriptionRef }: ServicePowerSlideRefs,
): void {
  const titleController = findTransitionController(titleRef);
  const descriptionController = findTransitionController(descriptionRef);

  if (titleController) {
    timeline.add(titleController.getTimeline('in') as gsap.core.Timeline, 0);
  }

  if (descriptionController) {
    timeline.add(descriptionController.getTimeline('in') as gsap.core.Timeline, 0.2);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { titleRef, descriptionRef }: ServicePowerSlideRefs,
): void {
  const titleController = findTransitionController(titleRef);
  const descriptionController = findTransitionController(descriptionRef);

  if (titleController) {
    timeline.add(titleController.getTimeline('out') as gsap.core.Timeline, 0);
  }

  if (descriptionController) {
    timeline.add(descriptionController.getTimeline('out') as gsap.core.Timeline, 0);
  }
}

export function scrollInTimeline(
  timeline: gsap.core.Timeline,
  { textContentRef }: ServicePowerSlideRefs,
): void {
  if (textContentRef?.current) {
    timeline
      .fromTo(
        textContentRef.current,
        {
          transform: 'translate3d(0, 20vh,0)',
        },
        {
          duration: 1,
          ease: 'Power1.easeOut',
          transform: 'translate3d(0, 0vh,0)',
        },
        0.5,
      )
      .to(
        textContentRef.current,
        {
          duration: 0.3,
          ease: 'Power1.easeIn',
          transform: 'translate3d(0, -90vh,0)',
        },
        1.5,
      )
      .to(
        textContentRef.current,
        {
          opacity: 0,
          duration: 0.2,
          ease: 'Power1.easeIn',
        },
        1.5,
      );
  }
  // if (titleRef?.current) {
  //   timeline.fromTo(
  //     titleRef.current,
  //     {
  //       transform: 'translate3d(0, 10vh,0)',
  //     },
  //     {
  //       duration: 1,
  //       ease: 'Power2.easeIn',
  //       transform: 'translate3d(0, -10vh,0)',
  //     },
  //     0.5
  //   );
  // }
  //
  // if (descriptionRef?.current) {
  //   timeline.fromTo(
  //     descriptionRef.current,
  //     {
  //       transform: 'translate3d(0, 10vh,0)',
  //     },
  //     {
  //       duration: 1,
  //       ease: 'Power2.easeIn',
  //       transform: 'translate3d(0, -10vh,0)',
  //     },
  //     0.5,
  //   )
  // }
}
